import React, { useState } from 'react';
import styles from "./AddNewImageModal.module.css"
import clsx from 'clsx';

interface AddNewImageModalProps {
    src?: string | null;
    isOpen?: boolean;
    onClose?: () => void;
    onSendClicked?: (file: File | null, name: string, description: string, category: number) => void;
}

const AddNewImageModal: React.FC<AddNewImageModalProps> = ({ src, isOpen = false, onClose, onSendClicked }) => {
    const categoryOptions = [
        { name: 'Transaction', value: 1 },
        { name: 'App Instruction', value: 2 },
        { name: 'Information', value: 3 },
    ];

    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState(0);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0] || null;
        setSelectedFile(file);
    };

    const handleOnSendClick = () => {
        onSendClicked && onSendClicked(selectedFile, name, description, category)
        setName("");
        setDescription("");
        setCategory(0)
    }

    const handleOnClose = () => {
        onClose && onClose()
        setName("");
        setDescription("");
        setCategory(0)
    }

    if (!isOpen) return null

    return (
        <div className={styles.modalOverlay} >
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div style={{ flex: 1, flexDirection: "row", display: "flex", gap: "16px" }}>
                    </div>
                    <button className={styles.closeButton} onClick={handleOnClose}>
                        ×
                    </button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.form}>
                        <div className={styles.uploadSection}>
                            <label htmlFor="image-upload">Upload Image:</label>
                            <input id="image-upload" type="file" accept="image/*" onChange={handleFileChange} />
                            {src && <img src={src} alt="Preview" className={styles.previewImage} />}
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="image-name">Name:</label>
                            <input id="image-name" type="text" value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="image-description">Description:</label>
                            <textarea id="image-description" value={description} onChange={e => setDescription(e.target.value)} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="image-category">Category:</label>
                            <select
                                id="image-category"
                                value={category}
                                onChange={e => setCategory(parseInt(e.target.value))}
                            >
                                <option value="0">Select a category</option>
                                {categoryOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={styles.modalFooter} >
                    <button className={clsx(styles.button, styles.warning)} onClick={handleOnClose}>
                        Cancel
                    </button>
                    <button className={clsx(styles.button, styles.primary)} onClick={handleOnSendClick}>
                        Add
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddNewImageModal;